import React, { useState, useRef, useEffect } from "react";
import ReactQuill , {Quill}  from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import SideBar from "../../Components/Navbar/Sidebar";
import { fetcheditBlog, gohBlogUpdate} from "../../Components/Apis/apis";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../Components/loader";

const Link = Quill.import('formats/link');

class CustomLink extends Link {
  static create(value) {
    let node = super.create(value);
    node.setAttribute('rel', 'dofollow');
    return node;
  }
}

Quill.register(CustomLink, true);

const EditBlogs = () => {
  const allCategory = [
    { for: 'gohoarding', cat: 'Billboard', value: 'billboard' },
    { for: 'gohoarding', cat: 'Digital billboard', value: 'digital-billboard' },
    { for: 'gohoarding', cat: 'Mall media', value: 'mall-media' },
    { for: 'gohoarding', cat: 'Inflight branding', value: 'inflight-branding' },
    { for: 'gohoarding', cat: 'Lift branding', value: 'lift-branding' },
    { for: 'gohoarding', cat: 'Transit media', value: 'transit-media' },
    { for: 'gohoarding', cat: 'Airport branding', value: 'airport-branding' },
    { for: 'newgoh', cat: 'Cinema', value: 'cinema' },
    { for: 'newgoh', cat: 'Digital OOH', value: 'digital-ooh' },
    { for: 'newgoh', cat: 'Magazine', value: 'magazine' },
    { for: 'newgoh', cat: 'Newspaper', value: 'newspaper' },
    { for: 'newgoh', cat: 'Radio', value: 'radio' },
    { for: 'newgoh', cat: 'Sports', value: 'sports' },
    { for: 'newgoh', cat: 'Television', value: 'television' },
    { for: 'pghive', cat: 'For Owner', value: 'for-owner' },
      { for: 'pghive', cat: 'For Tenant', value: 'for-tenant' },
    { for: 'influencer', cat: 'For Client', value: 'for-client'},
    { for: 'influencer', cat: 'For influencer', value: 'for-influencer'}
  ];
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [catOption, setCatOption] = useState([]);
  const [blogTitle, setBlogTitle] = useState("");
  const [blogUrl, setBlogUrl] = useState("");
  const [blogSummary, setBlogSummary] = useState("");
  const [blogKeywords, setBlogKeywords] = useState("");
  const [blogFor, setBlogFor] = useState("");
  const [blogCategory, setBlogCategory] = useState("");
  const [blogContent, setBlogContent] = useState("");
  const [blogImage, setBlogImage] = useState(null);
  const [blogImageNew, setBlogImageNew] = useState(null);
  const fileInputRef = useRef(null);

  const fetchPost = async () => {
    setLoading(true);
    const data = await fetcheditBlog(id);
    setLoading(false);
    if (data.success === false) {
      toast.error(data.message);
    } else {
        const postData = data[0]; 
        setBlogTitle(postData.title);
        setBlogUrl(postData.url);
        setBlogSummary(postData.summary);
        setBlogKeywords(postData.keywords);
        setBlogFor(postData.blog_for);
        setBlogCategory(postData.blogCategory);
        setBlogContent(postData.content);
        setBlogImage(postData.image);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPost();
    }
  }, [id]);

  useEffect(() => {
    const filteredCategories = allCategory.filter(
      (category) => category.for === blogFor
    );
    setCatOption(filteredCategories);
  }, [blogFor]);

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setBlogImageNew(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      blogImage &&
      blogTitle &&
      blogUrl &&
      blogFor &&
      blogCategory &&
      blogContent &&
      blogKeywords
    ) {
      const formData = new FormData();
      if(blogImageNew){
        formData.append("image", blogImageNew);
      }
      formData.append("id", id);
      formData.append("title", blogTitle);
      formData.append("url", blogUrl);
      formData.append("blogFor", blogFor);
      formData.append("blogCategory", blogCategory);
      formData.append("summary", blogSummary);
      formData.append("keywords", blogKeywords);
      formData.append("content", blogContent);
    
      const data = await gohBlogUpdate(formData);
      if (data.success === true) {
        toast(data.message);
      } else {
        toast.error(data.message);
      }
      
    } else {
      alert("All fields required");
    }
  };


  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <div className="container-pages ">

            {loading?  <Loader/> : <><div className="page-title">
            <h2>Update blog</h2>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-8">
                <div className="form-group">
                  {/* Input field for blog title */}
                  <label htmlFor="blogTitle">Blog Title:</label>
                  <input
                    type="text"
                    id="blogTitle"
                    className="form-control ms-0 mt-1"
                    value={blogTitle}
                    onChange={(e) => setBlogTitle(e.target.value)}
                    placeholder="Enter Blog Title"
                  />
                </div>

                <div className="form-group">
                  {/* Input field for blog URL */}
                  <label htmlFor="blogUrl">Blog URL:</label>
                  <input
                    type="text"
                    id="blogUrl"
                    className="form-control ms-0 mt-1"
                    value={blogUrl}
                    onChange={(e) => setBlogUrl(e.target.value)}
                    placeholder="Enter Blog URL"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="blogSummary">
                    Summary & Description (Meta Tag):
                  </label>
                  <textarea
                    id="blogSummary"
                    className="form-control ms-0 mt-1"
                    value={blogSummary}
                    onChange={(e) => setBlogSummary(e.target.value)}
                    rows={3}
                    placeholder="Enter Blog Summary"
                  />
                </div>

                <div className="form-group mt-2">
                  {/* Input field for blog URL */}
                  <label htmlFor="blogUrl">Keywords (Meta Tag):</label>
                  <input
                    type="text"
                    id="blogUrl"
                    className="form-control ms-0 mt-1"
                    value={blogKeywords}
                    onChange={(e) => setBlogKeywords(e.target.value)}
                    placeholder="Enter Keywords"
                  />
                </div>
              </div>
              <div className="col-4 ps-5">
                <div className="form-group">
                  <label htmlFor="blogUrl">Blog For:</label>
                  <select
                    id="blogUrl"
                    className="form-select ms-0   mt-1"
                    value={blogFor}
                    onChange={(e) => setBlogFor(e.target.value)}
                  >
                    <option value="gohoarding" selected>
                      Gohoarding
                    </option>
                    <option value="newgoh">New Goh</option>
                    <option value="pghive">PG Hive</option>
                    <option value="influencer">InfluencerSea</option>
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="blogUrl">Ctegory:</label>
                  <select
                    id="blogUrl"
                    className="form-select ms-0   mt-1"
                    value={blogCategory}
                    onChange={(e) => setBlogCategory(e.target.value)}
                  >
                    {catOption.map((option, index) => (
                      <option key={index} value={option.value}>
                        {option.cat}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="blogImage">click on image to update:</label>
                  <div
                    className="image-upload-box mt-1"
                    onClick={handleBoxClick}
                  >
                    {blogImage && (
                      <img
                        src={blogImageNew ? URL.createObjectURL(blogImageNew):blogImage}
                        alt="Blog"
                        style={{width: "180px",height:"120px"}}
                      />
                    )}
                  </div>
                  <input
                    type="file"
                    id="blogImage"
                    accept=".jpg, .png"
                    onChange={handleImageChange}
                    ref={fileInputRef} // Reference to the file input element
                    style={{ display: "none" }} // Hide the file input
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="blogContent" className="mb-1">
                Blog Content:
              </label>
              <ReactQuill
                id="blogContent"
                value={blogContent}
                onChange={setBlogContent}
                placeholder="Enter Blog Content"
                style={{ backgroundColor: "white" }}
              />
            </div>

            <div className="col-12 text-center">
              <div>
                {/* Submit button */}
                <button
                  type="submit"
                  className="btn btn-info text-light w-25 mt-3"
                >
                  Update
                </button>
                <ToastContainer />
              </div>
            </div>
          </form> </>}
          
        </div>
      </div>
    </>
  );
};

export default EditBlogs;
